import { gql, useApolloClient, useLazyQuery } from "@apollo/client";
import { DocProducerDocument } from "@/views/docproducer";

export const COMPLETED_TASK_QUERY = gql`
  query GetCompletedProcessTask($input: Json) {
    processCompletedTasks(
      includeProcessVariables: true
      maxCount: 5
      queryParams: $input
      includeFormDefinitions: false
    ) {
      total
      processTask {
        id
        processInstanceId
        processDefinitionId
        taskId
        data
      }
    }
  }
`;

export interface CompleteTaskQuery {
  processCompletedTasks: {
    processTask: ProcessTask[];
  };
}
export interface ProcessTask {
  id: string;
  processInstanceId: string;
  processDefinitionId: string;
  taskId: string;
  data: {
    returnValues: {
      documents: DocProducerDocument[];
      [key: string]: object;
    };
  };
}

export const useGetCompletedProcessTask = () => {
  const client = useApolloClient();

  const fetchCompletedTask = async (taskId: string) => {
    const { data, networkStatus } = await client.query<CompleteTaskQuery>({
      query: COMPLETED_TASK_QUERY,
      notifyOnNetworkStatusChange: true,
      variables: {
        input: { taskId },
      },
      fetchPolicy: "network-only", // tvinger nettverkskall, ikke cache
    });
    return { data, networkStatus };
  };

  return { fetchCompletedTask };
};
